

const isVerbose = process.env.REACT_APP_VERBOSE === 'true';
export default isVerbose